export default {
  fontSize: '1.6rem',
  displayContainer: 'grid',
  gridGapContainer: '1rem',
  gridTempCol: 'repeat(3,1fr)',
  gridTempColTab: 'repeat(2,1fr)',
  gridTempColMobile: 'repeat(1,1fr)',
  positionCont: 'relative',
};
